import { axiosPost } from 'modules/core/utils/axios';
import { loadAuthToken } from 'modules/core/utils/api';

export const reqZendeskAuth = axiosPost('/zendesk/sso', {
  headers: {
    Authorization: loadAuthToken() || '',
  },
});
